import { useEffect, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useHistory } from 'react-router-dom';
import SocialAuth from '../socialAuth';
import styles from './Signup.module.scss';
import loginStyles from '../Login/Login.module.scss';
import { useAuth } from 'contexts/AuthContext';
import SocialAuthProvider from 'constants/socialAuthProvider';
import { TextNormal, Text } from 'component/customize_style_component/styled_title';
import { PATH } from 'routes/constant';
import utils from 'utils/utils';
import config from 'config';
import StandardPopup from 'component/StandardPopup';
import { ToastType } from 'constants/index';
import loginSignupBackground from '../../../assets/img/signup-background2.png';
import logoSignUp from '../../../assets/img/logo_white.png';
import themes from 'styles/themes';
import CustomerOnboading from './onboarding';
import { TRACK_EVENT, trackEvent } from 'utils/analytics';
import { RootState, store } from 'redux/store';
import { ReactComponent as BackButton } from '../../../assets/svg/navLeft.svg';
import { ReactComponent as BackButtonBlack } from '../../../assets/svg/nav_left_black.svg';
import { useSelector } from 'react-redux';

export const VIEW_NAME = {
    SIGNUP_VIEW: 'signup_view',
    SIGNUP_OPTIONS: 'signup_options',
};

interface ISignup {
    isOpenedOnPopup?: boolean;
    onRedirect?: () => void;
}

export default function SignUp(props: ISignup) {
    const {
        isOpenedOnPopup = false,
        onRedirect = () => {
            console.log('onRedirect');
        },
    } = props;
    const { loginWithGoogle, socialLoginCallback, loginWithFacebook, loginWithApple, currentUser } = useAuth();

    const [isOnboading, setIsOnboarding] = useState(true);
    const defaultWidgetPath = useSelector((state: RootState) => state.widget.store?.defaultPagePath);

    let history = useHistory();

    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: '',
        button2: '',
        path: '',
        type: '',
        closeButton: true,
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (currentUser) {
            socialLoginCallback(currentUser).then(() => {
                onRedirect();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser]);

    async function handleSocialLogin(provider) {
        let socialAuthFunction;
        switch (provider) {
        case SocialAuthProvider.GOOGLE:
            socialAuthFunction = loginWithGoogle;
            break;
        case SocialAuthProvider.FACEBOOK:
            socialAuthFunction = loginWithFacebook;
            break;
        case SocialAuthProvider.APPLE:
            socialAuthFunction = loginWithApple;
            break;
        case SocialAuthProvider.EMAIL:
            onRedirect();
            history.push(PATH.SIGNUP_CUSTOMER_WITH_EMAIL);
            break;
        default:
            break;
        }
        try {
            setLoading(true);
            await socialAuthFunction();
            if (utils.isAppInWidgetMode()) sessionStorage.setItem('widgetSignupCompleted', JSON.stringify(true));
        } catch (err: any) {
            const errorCode = err.code;
            if (errorCode === 'auth/account-exists-with-different-credential') {
                setModalShow({
                    ...modalShow,
                    show: true,
                    title: 'Account already exists !',
                    content:
                        'This email has already been used with different authentication option. Please try a different authentication option or a different email.',
                    type: ToastType.Error,
                });
            }
            setLoading(false);
        }
    }

    const navigateToLogin = () => {
        onRedirect();
        history.push(PATH.LOGIN);
    };

    const handleFinishOnboardProcess = () => {
        trackEvent(TRACK_EVENT.SIGNUP_VIEW_LOADED, {
            view_name: VIEW_NAME.SIGNUP_OPTIONS,
        });
        setIsOnboarding(false);
    };

    const trackViewLoadedEvent = (viewIndex) => {
        const globalState = store.getState();
        if (utils.isAppInWidgetMode() && !globalState.widget.sourceUrl) {
            return;
        }

        trackEvent(TRACK_EVENT.SIGNUP_VIEW_LOADED, {
            view_name: `${VIEW_NAME.SIGNUP_VIEW}_${viewIndex}`,
        });
    };

    const handleLogoRedirect = () => {
        onRedirect();
        if (utils.isAppInWidgetMode()) {
            history.push(defaultWidgetPath);
        }
    };

    const viewPortHeight: any = use100vh();

    return isOnboading && !isOpenedOnPopup ? (
        <>
            {utils.isAppInWidgetMode() && defaultWidgetPath !== PATH.SIGNUP_CUSTOMER && !isOpenedOnPopup && (
                <BackButtonBlack className={styles.backButton} onClick={() => history.push(defaultWidgetPath)} />
            )}
            <CustomerOnboading
                onViewChanged={trackViewLoadedEvent}
                handleFinishOnboardProcess={handleFinishOnboardProcess}
            />
        </>
    ) : (
        <div
            className={loginStyles.loginContainer}
            style={{
                background: `linear-gradient(180deg, rgba(0, 0, 0, 0.0824444) 19.28%, rgba(0, 0, 0, 0.53) 72.21%, rgba(0, 0, 0, 0.53) 100%), url(${loginSignupBackground})`,
                height: isOpenedOnPopup ? `calc(${viewPortHeight}px - 109px)` : `calc(${viewPortHeight}px)`,
                borderRadius: isOpenedOnPopup ? '20px 20px 0px 0px' : '0px',
                overflow: 'scroll',
            }}
        >
            {utils.isAppInWidgetMode() && defaultWidgetPath !== '/signup' && !isOpenedOnPopup && (
                <BackButton
                    style={{ position: 'absolute', left: 20, top: 20 }}
                    onClick={() => history.push(defaultWidgetPath)}
                />
            )}
            <div className="pt-3">
                <img
                    src={logoSignUp}
                    width="69px"
                    height={'auto'}
                    alt="logo"
                    onClick={handleLogoRedirect}
                    style={{ cursor: 'pointer' }}
                />
            </div>
            <div>
                <h6 className={`text-white my-3 px-4 ${loginStyles.welcomeText}`}>Personalized Styling Made Simple</h6>
                <SocialAuth
                    styles={loginStyles}
                    handleSocialLogin={handleSocialLogin}
                    mode="signUp"
                    loading={loading}
                />
                <div className={`${styles.noProfile}`}>
                    <TextNormal className="mt-4 mb-1" color="#fff">
                        Have an account ?
                        <p
                            onClick={navigateToLogin}
                            className={loginStyles.signupLink}
                            style={{ color: themes.palette.warning['500'], display: 'inline' }}
                        >
                            {' '}
                            Log in
                        </p>
                    </TextNormal>
                </div>
                <div className="my-4 px-4">
                    <Text size={10} color={'white'}>
                        By clicking the Signup buttons above, you acknowledge that you have read and agree to Taffi’s{' '}
                        {utils.getAnchorNewTab(config.termsOfService.url, config.termsOfService.text, {
                            fontFamily: 'Open Sans',
                            opacity: 1,
                            color: '#FFEEB3',
                            textDecoration: 'none',
                        })}{' '}
                        and{' '}
                        {utils.getAnchorNewTab(config.privacyPolicy.url, config.privacyPolicy.text, {
                            fontFamily: 'Open Sans',
                            opacity: 1,
                            color: '#FFEEB3',
                            textDecoration: 'none',
                        })}
                    </Text>
                </div>
            </div>
            <StandardPopup
                show={modalShow.show}
                onHide={() => setModalShow({ ...modalShow, show: false })}
                title={modalShow.title}
                content={modalShow.content}
                button1={modalShow.button1}
                button2={modalShow.button2}
                type={modalShow.type as any}
                closeButton={modalShow.closeButton}
            />
        </div>
    );
}
